import type { ExploreContentResponsePage } from './exploreContentResponsePage';

export interface ExploreContentResponse {
  code?: string;
  message?: string;
  page?: ExploreContentResponsePage;
  success?: boolean;
}
